import {
  ON_START_ESIGNERING_ORGNR_DELETE,ON_ESIGNERING_ORGNR_DELETE,ON_ERROR_ESIGNERING_ORGNR_DELETE,
  ON_START_GET_SIGNERAD_FILE,ON_GET_SIGNERAD_FILE,ON_ERROR_GET_SIGNERAD_FILE,
    ON_START_NEW_ESIGNERING,ON_NEW_ESIGNERING,ON_ERROR_NEW_ESIGNERING,
    ON_START_GET_ESIGNERIGN_USER,ON_GET_ESIGNERIGN_USER,ON_ERROR_GET_ESIGNERIGN_USER,
    ON_START_GET_ESIGNERIGN_ORGNR,ON_GET_ESIGNERIGN_ORGNR,ON_ERROR_GET_ESIGNERIGN_ORGNR,
    ON_START_GET_ESIGNERIGN_AVTAL,ON_GET_ESIGNERIGN_AVTAL,ON_ERROR_GET_ESIGNERIGN_AVTAL,
    ON_START_GET_ESIGNERIGN_ID,ON_GET_ESIGNERIGN_ID,ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS,ON_ERROR_GET_ESIGNERIGN_ID,
    ON_START_GET_TIMELINE,ON_GET_ESIGNERIGN_TIMELINE,ON_ERROR_GET_ESIGNERIGN_TIMELINE,
    ON_START_ESIGNERING_SKICKA,ON_ESIGNERING_SKICKA,ON_ERROR_ESIGNERING_SKICKA,
    ON_START_ESIGNERING_RECALL,ON_ESIGNERING_RECALL,ON_ERROR_ESIGNERING_RECALL,
    ON_START_ESIGNERING_RESTART,ON_ESIGNERING_RESTART,ON_ERROR_ESIGNERING_RESTART,
    ON_START_ESIGNERING_DELETE,ON_ESIGNERING_DELETE,ON_ERROR_ESIGNERING_DELETE,
    ON_START_GET_ESIGNERIGN_HISTORY,ON_GET_ESIGNERIGN_HISTORY,ON_ERROR_GET_ESIGNERIGN_HISTORY,
    ON_START_UPDATE_ESIGNERIGN_MESSAGE,ON_UPDATE_ESIGNERIGN_MESSAGE,ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE,
    ON_START_UPDATE_ESIGNERIGN_MOTAGARE,ON_UPDATE_ESIGNERIGN_MOTAGARE,ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE,
    ON_START_NEW_ESIGNERIGN_MOTAGARE,ON_NEW_ESIGNERIGN_MOTAGARE,ON_ERROR_NEW_ESIGNERIGN_MOTAGARE,
    ON_START_DELETE_ESIGNERIGN_MOTAGARE,ON_DELETE_ESIGNERIGN_MOTAGARE,ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE,
    ON_START_UPDATE_ESIGNERIGN_FILE,ON_UPDATE_ESIGNERIGN_FILE,ON_ERROR_UPDATE_ESIGNERIGN_FILE,
    ON_START_SEND_ESIGNERIGN_REMAINDER,ON_SEND_ESIGNERIGN_REMAINDER,ON_ERROR_SEND_ESIGNERIGN_REMAINDER,
    ON_START_ADD_ESIGNERIGN_ATTAC_FILE,ON_ADD_ESIGNERIGN_ATTAC_FILE,ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE,
    ON_START_DEL_ATT_FILE,ON_DEL_ATT_FILE,ON_ERROR_DEL_ATT_FILE,
    ON_START_GET_SIG_FILE,ON_GET_SIG_FILE,ON_ERROR_GET_SIG_FILE, SET_ESIGNVY_TYPE,
    SET_ESIGNVY_PAGE_ROWS,
    ON_START_ESIGNERING_NEW_FREEIPUT,ON_ESIGNERING_NEW_FREEIPUT,ON_ERROR_ESIGNERING_NEW_FREEIPUT,
    ON_START_ESIGNERING_DELETE_FREEIPUT,ON_ESIGNERING_DELETE_FREEIPUT,ON_ERROR_ESIGNERING_DELETE_FREEIPUT,
    ON_START_ESIGNERING_EDIT_FREEIPUT,ON_ESIGNERING_EDIT_FREEIPUT,ON_ERROR_ESIGNERING_EDIT_FREEIPUT,
    ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    FETCH_START_SET_UNAUTHE,
    ON_START_ESIGNERING_UPDATE_NYTT,
		ON_GET_UPDATE_ESIGNERING,
		ON_GET_UPDATE_ESIGNERING_ERROR,
		ON_GET_UPDATE_ESIGNERING_KUNDNAMN,
} from "../constants/ActionTypes";
import axios from 'util/Api' 
import { history } from "store";
import { isEmpty,isUndefined } from "lodash";
import {userSignOut} from 'actions'
import {RefreshUserInterface} from 'actions'
import fileSaver from 'file-saver' 
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'

//
const getClientIp = async () => {
  let Ipadress='0.0.0.0'
  return Ipadress
}


 export const setupdateesignering = (data) => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_ESIGNERING, payload: data});
   }
}
 export const setupdateesigneringerror = (data) => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_ESIGNERING_ERROR, payload: data});
   }
}
 export const setupdateesignering_kundnamn = (data) => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_ESIGNERING_KUNDNAMN, payload: data});
   }
}
//CreateEsignering
export const CreateEsignering = ( Afid, userid,NewSignering) =>{
    const jwt =  JSON.parse(localStorage.token);
   
    return async (dispatch) => {
    const ipAdress='0.0.0.0'
    let files = isEmpty(NewSignering.Document.file)?[]:NewSignering.Document.file; 
    console.log(files)
    
    var fromdata = new FormData();
    fromdata.append("Afid",Afid)
    fromdata.append("userid",userid)
    fromdata.append("ipAdress",ipAdress)
    fromdata.append("NewSignering",JSON.stringify(NewSignering))
    files.forEach(file => fromdata.append('files[]', file));
    console.log(1)
       dispatch({type: ON_START_NEW_ESIGNERING});
       dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Creating.E-singing")});
       axios.post('kontos/Esignering/new',
       fromdata,
       {
        body: {
            NewSignering:NewSignering,
            Afid:Afid,
            userid:userid,
            ipAdress:ipAdress
        },
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("CreateEsignering: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_NEW_ESIGNERING, payload: data.results});
           dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Esigning.Create",`E-signering #19${data.results.CurrentEsignering.Esignering[0].id} har skapats`,{item:data.results.CurrentEsignering.Esignering[0].id})});
           //if(isUndefined(data.results.CurrentEsignering.isGetAccept)){
            history.push({
              pathname: '/app/EsigneringKort',
              state: { 
                Esignering: data.results.CurrentEsignering.Esignering[0].id,
                EsigneringFrom: data.results.CurrentEsignering.EsigneringFrom,
               }
            });
           //}          
         } else {
           dispatch({type: ON_ERROR_NEW_ESIGNERING, payload: data.error});
           dispatch({type: ON_ERROR_MESSAGE_KUND, payload: data.error});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_NEW_ESIGNERING, payload: error.message});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload:error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
   
//getEsigneringHistory
export const getEsigneringHistory = (EsigneringId,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ESIGNERIGN_HISTORY});
    axios.get('kontos/Esignering/getHistoryById',
    { params:encrypt(JSON.stringify({
      EsigneringId:EsigneringId,ipAdress,EsigneringFrom
    }))}, { 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data  => {
      console.log("getEsigneringHistory: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ESIGNERIGN_HISTORY, payload: ndate.results});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ESIGNERIGN_HISTORY, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_HISTORY, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//UpdateInvetationMessageEsignering
export const UpdateInvetationMessageEsignering = (Afid,userid,EsigneringId,Orgnr,Message,Lang , EsigineringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_ESIGNERIGN_MESSAGE});
    axios.put('kontos/Esignering/UpdateMessage',
    {
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,
      Lang:Lang,
      Message:Message,ipAdress,EsigineringFrom
    }))},{ 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data => {
      console.log("UpdateInvetationMessageEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("UpdateInvetationMessageEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_ESIGNERIGN_MESSAGE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("UpdateInvetationMessageEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ESIGNERIGN_MESSAGE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//UpdateMotagareEsignering
export const UpdateMotagareEsignering = (Afid,userid,EsigneringId,Orgnr,Motagare,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_ESIGNERIGN_MOTAGARE});
    axios.put('kontos/Esignering/UpdateMotagare',
    {
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,
      Motagare:Motagare,ipAdress,
      EsigneringFrom
    }))}, { 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data => {
      console.log("UpdateMotagareEsignering: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("UpdateMotagareEsignering1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_UPDATE_ESIGNERIGN_MOTAGARE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("UpdateMotagareEsignering2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE, payload: ndate.error});
        }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ESIGNERIGN_MOTAGARE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SaveNewMottagareEsignering
export const SaveNewMottagareEsignering = (Afid,userid,EsigneringId,Orgnr,Motagare,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_NEW_ESIGNERIGN_MOTAGARE});
    axios.put('kontos/Esignering/NewMotagare',
    {
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,
      Motagare:Motagare,ipAdress,
      EsigneringFrom
    }))}, { 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data => {
      console.log("SaveNewMottagareEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("SaveNewMottagareEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_NEW_ESIGNERIGN_MOTAGARE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_NEW_ESIGNERIGN_MOTAGARE, payload: ndate.error});
      }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_ESIGNERIGN_MOTAGARE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//DeleteThisMottagare
export const DeleteThisMottagare = (Afid,userid,EsigneringId,Orgnr,Motagare,EsigneringFrom=1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_DELETE_ESIGNERIGN_MOTAGARE});
    axios.put('kontos/Esignering/DeleteMotagare',
    {
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,
      Motagare:Motagare,ipAdress,
      EsigneringFrom
    }))},{
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data => {
      console.log("DeleteThisMottagare: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("DeleteThisMottagare1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_DELETE_ESIGNERIGN_MOTAGARE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getEsigneringHistory2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE, payload: ndate.error});

        }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_ESIGNERIGN_MOTAGARE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//UpdateFileEsignering
export const UpdateFileEsignering = (Afid,userid,EsigneringId,Orgnr,file,EsigneringFrom=1) =>{
  const jwt =  JSON.parse(localStorage.token);
 
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
     var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("EsigneringId",EsigneringId)
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("ipAdress",ipAdress)
  fromdata.append("EsigneringFrom",EsigneringFrom)
  fromdata.append('files[]', file);
    dispatch({type: ON_START_UPDATE_ESIGNERIGN_FILE});
    axios.post('kontos/Esignering/UpdateFile',
       fromdata,
       {
        body: {
          Afid:Afid,
          userid:userid,
          EsigneringId:EsigneringId,
          Orgnr:Orgnr,ipAdress,
          EsigneringFrom
        },
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
        }       
      }
     ).then(({data}) => {
      console.log("UpdateFileEsignering: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_ESIGNERIGN_FILE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_ESIGNERIGN_FILE, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_ESIGNERIGN_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getAvtalEsigneringById
export const getAvtalEsigneringById = (Afid, userid,avtal) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ESIGNERIGN_AVTAL});
    axios.get('kontos/Esignering/getByAvtalId',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      avtal:avtal,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getAvtalEsigneringById: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ESIGNERIGN_AVTAL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ESIGNERIGN_AVTAL, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_AVTAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getEsigneringByOrgnr
export const getEsigneringByOrgnr = (Afid, userid,Orngr,page,type,searshWord) =>{
  let Page = isUndefined(page)?0:page
  let Type = isUndefined(type)?0:type
  let SearshWord = isUndefined(searshWord)?"":searshWord
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ESIGNERIGN_ORGNR});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Esigning.fetching")});
    //ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    axios.get('kontos/Esignering/getByOrngr',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Page:Page,
      Type:Type,
      SearshWord:SearshWord,
      Orngr:Orngr,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getEsigneringByOrgnr: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringByOrgnr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ESIGNERIGN_ORGNR, payload: ndate.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Esigning.fetch")});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ESIGNERIGN_ORGNR, payload: ndate.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Esigning.fetching")});
      }
      
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_ORGNR, payload: error.message});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Esigning.fetching")});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//HereJack
//getEsigneringByUserID
export const getEsigneringByUserID = (Afid,Filterstate, userid,Page,searchTextd, Type,pageRows) =>{
  const jwt =  JSON.parse(localStorage.token);
  let page = isUndefined(Page)?0:Page
  pageRows = isUndefined(pageRows)?15:pageRows
  let searchText = isUndefined(searchTextd)?"":searchTextd
  Type = isUndefined(Type) ? 0 : Type
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ESIGNERIGN_USER});
    axios.get('kontos/Esignering/getByUser',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Page:page,
      pageRows:pageRows,
      Filterstate:Filterstate,
      searchText:searchText,ipAdress,
      Type:Type
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
        console.log("getEsigneringByUserID: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getEsigneringByUserID1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_ESIGNERIGN_USER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getEsigneringByUserID2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_ESIGNERIGN_USER, payload: ndate.error});
        }    
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}


//getEsignering
export const getEsignering = (Afid,userid,Esignering, fromOffert,EsigneringFrom=1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ESIGNERIGN_ID});
    axios.get('kontos/Esignering/getById',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,Esignering:Esignering,ipAdress,EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        history.push({
          pathname: '/app/EsigneringKort',
          state: { Esignering: ndate.results.CurrentEsignering.Esignering[0].id,
            EsigneringFrom:EsigneringFrom
           }
        });
        if(fromOffert){
          dispatch({type: ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS, payload: ndate.results});
         } else {
          dispatch({type: ON_GET_ESIGNERIGN_ID, payload: ndate.results});
         }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ESIGNERIGN_ID, payload: ndate.error});
      }

       
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
export const getEsignering2 = (Afid,userid,Esignering, fromOffert,EsigneringFrom=1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.get('kontos/Esignering/getById',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,Esignering:Esignering,ipAdress,EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ESIGNERIGN_ID_FROM_OFFERT_PROCESS, payload: ndate.results});        
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ESIGNERIGN_ID, payload: ndate.error});
      }

       
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//getEsigneringTimeLine
export const getEsigneringTimeLine = (Esignering,Doc_id,Afid,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_TIMELINE});
    axios.get('kontos/Esignering/TimeLine',
    { params:encrypt(JSON.stringify({
      Esignering:Esignering,Doc_id:Doc_id,ipAdress,Afid,EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getEsigneringTimeLine: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringTimeLine1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ESIGNERIGN_TIMELINE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ESIGNERIGN_TIMELINE, payload: ndate.error});
      }      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ESIGNERIGN_TIMELINE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//SkickEsignering
export const SkickEsignering = (Afid,userid,EsigneringId,Orgnr,AvtalId, EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_ESIGNERING_SKICKA});
    axios.get('kontos/Esignering/Skicka',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,Esignering:EsigneringId,Orgnr:Orgnr,AvtalId:AvtalId,ipAdress,EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("SkickEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("SkickEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_SKICKA, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("SkickEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_SKICKA, payload: ndate.error});
      }
      
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_SKICKA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//RecallEsignering
export const RecallEsignering = (Afid,userid,EsigneringId,Orgnr,AvtalId,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_ESIGNERING_RECALL});
    axios.get('kontos/Esignering/Recall',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,Esignering:EsigneringId,Orgnr:Orgnr,AvtalId:AvtalId,ipAdress,EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("RecallEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("RecallEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_RECALL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("RecallEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_RECALL, payload: ndate.error});
      }
      
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_RECALL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//RestartEsignering
export const RestartEsignering = (Afid,userid,EsigneringId,Orgnr,AvtalId,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_ESIGNERING_RESTART});
    axios.get('kontos/Esignering/Restart',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,Esignering:EsigneringId,Orgnr:Orgnr,AvtalId:AvtalId,ipAdress,
      EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("RestartEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("RestartEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_RESTART, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("RestartEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_RESTART, payload: ndate.error});
      }
     
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_RESTART, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//DeleteEsignering
export const DeleteEsignering = (Afid,userid,EsigneringId,Orgnr,AvtalId,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_ESIGNERING_DELETE});
    axios.get('kontos/Esignering/Delete',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,Esignering:EsigneringId,Orgnr:Orgnr,AvtalId:AvtalId,ipAdress,
      EsigneringFrom,
      Filterstate:isUndefined(localStorage.EsigneringFilter)?[]:JSON.parse(localStorage.EsigneringFilter)
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data  => {
      console.log("DeleteEsignering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("DeleteEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_DELETE, payload: ndate.results});
        try{
          console.log(window.history,"ON_ESIGNERING_DELETE")
          window.history.back();
         }
         catch(error){
          history.push({
            pathname: '/app/Esignering'
          });
         }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("DeleteEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_DELETE, payload: ndate.error});
      }
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_DELETE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//onDeleteThisEsignergin
export const onDeleteThisEsignergin = (userid,Afid,Esignering) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_ESIGNERING_ORGNR_DELETE});
    axios.delete('kontos/Kund/Esignering/Delete',
    { 
      method: 'DELETE',
      params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Esignering:JSON.stringify(Esignering),
      IpAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data  => {
      console.log("DeleteEsignering: ", data);
      if(data.data.success){  
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("DeleteEsignering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_ORGNR_DELETE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("DeleteEsignering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_ORGNR_DELETE, payload: ndate.error});
      }
      
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_ORGNR_DELETE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//getSegneradFile
export const getSegneradFile = (Afid,userid,EsigneringId,Orgnr,EsigneringFrom =1 ) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_SIGNERAD_FILE});
    axios.get('kontos/Esignering/getSfile',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,ipAdress,
      EsigneringFrom
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getSegneradFile: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getSegneradFile1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_SIGNERAD_FILE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getSegneradFile2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_SIGNERAD_FILE, payload: ndate.error});
      }
       
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SIGNERAD_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//getFiletoNogyfileData
export const getFiletoNogyfileData = (Afid,userid,EsigneringId,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    axios.get('kontos/Esignering/getTfile',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr
    })),
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log(data)
     })
     .catch(function (error) {
      console.log(error.response.status)
     })
  }
}
//getThisFile
export const getThisFile = (Afid,userid,EsigneringId,Orgnr,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_SIG_FILE});
    axios.get('kontos/Esignering/getSigfile',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,ipAdress,EsigneringFrom
    })),
    responseType: 'arraybuffer' , 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
      const dirtyFileName = resp.headers['content-disposition'];
      console.log(dirtyFileName)
      const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = dirtyFileName.match(regex)[3];
      var blob = new Blob([resp.data], 
       { type: 'application/pdf' }
     );
     dispatch(RefreshUserInterface(userid))
     fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_GET_SIG_FILE})
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SIG_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
export const setEsignVyType = (Type) => {
  return (dispatch) => {
    dispatch({type:SET_ESIGNVY_TYPE,payload:Type});
  }
}
export const setEsignPageRows = (PageRows) => {
  return (dispatch) => {
    dispatch({type:SET_ESIGNVY_PAGE_ROWS,payload:PageRows});
  }
}
//sendReaminderScrive
export const sendReaminderScrive = (Afid,userid,EsigneringId,Orgnr,docId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_SEND_ESIGNERIGN_REMAINDER});
    axios.put('kontos/Esignering/Remaind',
    {
    method: 'PUT',
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      Orgnr:Orgnr,
      docId:docId,
      ipAdress
    }))},
    {
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data => {
      console.log("sendReaminderScrive: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("sendReaminderScrive1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_SEND_ESIGNERIGN_REMAINDER, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("sendReaminderScrive2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_SEND_ESIGNERIGN_REMAINDER, payload: ndate.error});
      }
     
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SEND_ESIGNERIGN_REMAINDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//AddEsigneringAttachment
export const AddEsigneringAttachment = (Afid,userid,Orgnr,AvtalId,EsigneringId,file,filename,DocId, EsigneringFrom) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(file)
  return async (dispatch) => {
    let files = isEmpty(file)?[]:file; 
    const ipAdress='0.0.0.0'
    var fromdata = new FormData();
    fromdata.append("Afid",Afid)
    fromdata.append("userid",userid)
    fromdata.append("EsigneringId",EsigneringId)
    fromdata.append("Orgnr",Orgnr)
    fromdata.append("DocId",DocId)
    fromdata.append("AvtalId",AvtalId)
    fromdata.append("filename",filename)
    fromdata.append("ipAdress",ipAdress)
    fromdata.append("EsigneringFrom",EsigneringFrom)
    files.forEach(file => fromdata.append('files[]', file));
    dispatch({type: ON_START_ADD_ESIGNERIGN_ATTAC_FILE});
    axios.post('kontos/Esignering/Attach/new',
       fromdata,
       {
        body: {
          Afid:Afid,
          userid:userid,
          EsigneringId:EsigneringId,
          AvtalId:AvtalId,
          filename:filename,
          DocId:DocId,
          Orgnr:Orgnr,ipAdress,EsigneringFrom
        },
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
        }       
      }
     ).then(({data}) => {
      console.log("AddEsigneringAttachment: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_ADD_ESIGNERIGN_ATTAC_FILE, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ADD_ESIGNERIGN_ATTAC_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//GetEsigneringAttachment
export const GetEsigneringAttachment = (Afid,userid,DocId,file_id,FileIId,filename,EsigneringId,EsigneringFrom = 1) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_SIG_FILE});
    axios.get('kontos/Esignering/Attach/get',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      DocId:DocId,
      file_id:file_id,
      EsigneringId:EsigneringId,
      filename:filename,
      ipAdress,EsigneringFrom,FileIId
    })),
    responseType: 'arraybuffer' , 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
      
     // const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = filename;
      var blob = new Blob([resp.data], 
       { type: 'application/pdf' }
     );
     fileSaver.saveAs(blob, fileName);
     dispatch({type: ON_GET_SIG_FILE})
     dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SIG_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}   
//deleteEsigneringAttachment
export const deleteEsigneringAttachment = (Afid,userid,DocId,file_id,FileIId,filename,EsigneringId,EsigneringFrom = 1 ) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_DEL_ATT_FILE});
    axios.get('kontos/Esignering/Attach/delete',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      DocId:DocId,
      file_id:file_id,
      FileIId:FileIId,
      EsigneringId:EsigneringId,
      filename:filename,
      ipAdress,
      EsigneringFrom
    })),
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("deleteEsigneringAttachment: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteEsigneringAttachment1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DEL_ATT_FILE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteEsigneringAttachment2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_DEL_ATT_FILE, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DEL_ATT_FILE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
  }
}   
//onAddNewFreeInputEsingering
export const onAddNewFreeInputEsingering = (Afid,userid,EsigneringId,nFreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_ESIGNERING_NEW_FREEIPUT});
    axios.put('kontos/Esignering/FreeInput/new',
    {
    method: 'PUT',
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      nFreeInput:nFreeInput
    }))},{
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data  => {
      console.log("onAddNewFreeInputEsingering: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onAddNewFreeInputEsingering1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_NEW_FREEIPUT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("onAddNewFreeInputEsingering2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_NEW_FREEIPUT, payload: ndate.error});
      }
      
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_NEW_FREEIPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//ondeleteThisFreeInput
export const ondeleteThisFreeInput = (Afid,userid,EsigneringId,FreeInputId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_ESIGNERING_DELETE_FREEIPUT});
    axios.delete('kontos/Esignering/FreeInput/delete',
    {
    method: 'DELETE',
    params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      FreeInputId:FreeInputId
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data => {
      console.log("ondeleteThisFreeInput: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("ondeleteThisFreeInput1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ESIGNERING_DELETE_FREEIPUT, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("ondeleteThisFreeInput2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ESIGNERING_DELETE_FREEIPUT, payload: ndate.error});
        }
      
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_DELETE_FREEIPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
//onEditThisFreeInput
export const onEditThisFreeInput = (Afid,userid,EsigneringId,nFreeInput) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    //,invitationM,
      //invitationM:invitationM,
    dispatch({type: ON_START_ESIGNERING_EDIT_FREEIPUT});
    axios.put('kontos/Esignering/FreeInput/edit',
    {
    body:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      EsigneringId:EsigneringId,
      nFreeInput:nFreeInput
    }))},{ 
     headers: { 'Authorization': `Bearer ${jwt}`}   }
     ).then( data  => {
      console.log("onEditThisFreeInput: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ESIGNERING_EDIT_FREEIPUT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ESIGNERING_EDIT_FREEIPUT, payload: ndate.error});
      }
      
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ESIGNERING_EDIT_FREEIPUT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){ } 
     });
  }
}
export const onCloseEsigneringToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_START_ESIGNERING_UPDATE_NYTT});
  }
}